import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the dashboardContainer state domain
 */

const selectDashboardContainerDomain = state =>
  state.dashboardContainer || initialState;

const selectMerchantDetails = state =>
  state.dashboardContainer && state.dashboardContainer.merchantDetails;

const selectSubscriptionsConfig = state =>
  state.dashboardContainer && state.dashboardContainer.subscriptionsConfig;

const selectDashboardLoadingStatus = state =>
  state.dashboardContainer &&
  state.dashboardContainer.dashboardContainerLoaders;

const selectUserType = state => state.dashboardContainer?.userType;

/**
 * Other specific selectors
 */

/**
 * Default selector used by DashboardContainer
 */

const makeSelectDashboardContainer = () =>
  createSelector(
    selectDashboardContainerDomain,
    substate => substate,
  );

export const selectMerchantDetailsSelector = () =>
  createSelector(
    selectMerchantDetails,
    substate => substate,
  );

export const selectSubscriptionsConfigSelector = () =>
  createSelector(
    selectSubscriptionsConfig,
    substate => substate,
  );

export const selectDashboardLoadingStatusSelector = () =>
  createSelector(
    selectDashboardLoadingStatus,
    substate => substate,
  );

export const userTypeSelector = () =>
  createSelector(
    selectUserType,
    substate => substate,
  );

export default makeSelectDashboardContainer;
export { selectDashboardContainerDomain };
